import React from "react";

import Text from "src/components/text";

import _ from "lodash";
import styles from "./sharesListItem.module.scss";
import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface ShareListItem {
  user: User;
  analytics: Analytics;
}

export interface SharesListItemProps {
  item: ShareListItem;
  columnCount: number;
}

export const SharesListItem: React.FC<SharesListItemProps> = ({
  item,
  columnCount,
}) => {
  const { user, analytics } = item;
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={user.icon?.thumbnail || DefaultAssetIcon}
          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
          alt={`${user.firstName} ${user.lastName}`}
        />
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <Text
              lines={1}
              className={styles.title}
              text={`${user.firstName} ${user.lastName}`}
            />
          </div>
          <span className={styles.metricsData}>
            <span className={styles.name}>
              {user.createdDate && (
                <>
                  Joined:{" "}
                  {new Date(user.createdDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </>
              )}
            </span>
            <span className={styles.name}>
              Role: {user.admin ? "Administrator" : "User"}
            </span>
          </span>
          <span className={styles.meta}>
            {user.lastActivityDate && (
              <>
                Last Active on:{" "}
                {new Date(user.lastActivityDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </>
            )}
          </span>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.shares}</div>
        <div className={styles.tableDataTime}>{analytics.assets}</div>
        <div className={styles.tableDataShares}>{analytics.recipients}</div>
      </div>
    </div>
  );
};
